export enum OcrScene {
  /**
   * 个人认证: 身份证人像面
   */
  PERSON_AUDIT_IDCARD_FRONT = 0,

  /**
   * 个人认证: 身份证背面
   */
  PERSON_AUDIT_IDCARD_BACK = 1,

  /**
   * 企业认证营: 业执照
   */
  ENTERPRISE_AUDIT_LICENSE = 2,

  /**
   * 企业认证: 法人身份证人像面
   */
  ENTERPRISE_AUDIT_LEGAL_PERSON_IDCARD_FRONT = 3,

  /**
   * 企业认证: 法人身份证国徽面
   */
  ENTERPRISE_AUDIT_LEGAL_PERSON_IDCARD_BACK = 4
}
